module.exports = __webpack_public_path__ + "static/Banner carrousel home Enero-05-75b3d75a39eddb050e87b3fab0929f66.jpg";